import { render } from "./VUEComponenteGraficoGV.vue?vue&type=template&id=5de04663"
import script from "./VUEComponenteGraficoGV.vue?vue&type=script&lang=js"
export * from "./VUEComponenteGraficoGV.vue?vue&type=script&lang=js"

import "./VUEComponenteGraficoGV.vue?vue&type=style&index=0&id=5de04663&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__